export const initialState = []

export const set = (state, payload) => payload
